/* Fluxcase B V2: loading screen, newsletter validation, cookie choice. Each part is independent and fails quietly. */
(function(){
  var doc = document, root = doc.documentElement;

  /* ---------- Loading screen: clear on load, never later than the cap ---------- */
  (function(){
    var el = doc.querySelector('[data-loader]');
    if(!el) return;
    var seen = root.classList.contains('fc-seen');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var done = false;
    function hide(){
      if(done) return; done = true;
      el.classList.add('is-done');
      setTimeout(function(){ if(el.parentNode) el.parentNode.removeChild(el); }, 400);
    }
    var cap = reduce ? 0 : (seen ? 250 : 1500);
    setTimeout(hide, cap);
    if(doc.readyState === 'complete') hide();
    else window.addEventListener('load', hide);
    window.addEventListener('pageshow', function(e){ if(e.persisted) hide(); });
  })();

  /* ---------- Newsletter: inline validation, Shopify handles the rest ---------- */
  (function(){
    var form = doc.getElementById('fcNewsForm');
    if(!form) return;
    var input = form.querySelector('input[type="email"]');
    var msg = form.querySelector('[data-news-msg]');
    if(!input || !msg) return;
    form.setAttribute('novalidate', '');
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    function setError(text){
      input.setAttribute('aria-invalid', 'true');
      msg.className = 'fc-news-msg is-error';
      msg.textContent = text;
    }
    function clear(){
      if(input.getAttribute('aria-invalid') !== 'true') return;
      input.removeAttribute('aria-invalid');
      msg.className = 'fc-news-msg';
      msg.textContent = '';
    }
    form.addEventListener('submit', function(e){
      var v = (input.value || '').trim();
      input.value = v;
      if(!v){ e.preventDefault(); setError('Enter your email address.'); input.focus(); return; }
      if(!re.test(v)){ e.preventDefault(); setError('That email address doesn’t look right. Check it and try again.'); input.focus(); return; }
      var btn = form.querySelector('button[type="submit"]');
      if(btn){ btn.disabled = true; btn.textContent = 'Signing up...'; }
    });
    input.addEventListener('input', clear);
    /* After Shopify posts back, bring the result into view */
    if(/[?&]customer_posted=true/.test(location.search) || msg.textContent.trim()){
      var sec = doc.getElementById('newsletter');
      if(sec && msg.textContent.trim()){ try{ sec.scrollIntoView({block:'center'}); }catch(err){} }
    }
  })();

  /* ---------- Cookie choice ---------- */
  (function(){
    var box = doc.querySelector('[data-cookie]');
    if(!box) return;
    var KEY = 'fc-cookie-choice';
    function stored(){ try{ return localStorage.getItem(KEY); }catch(e){ return null; } }
    function store(v){ try{ localStorage.setItem(KEY, v); }catch(e){} }

    function withPrivacy(cb){
      try{
        var S = window.Shopify;
        if(S && S.customerPrivacy){ cb(S.customerPrivacy); return; }
        if(S && typeof S.loadFeatures === 'function'){
          S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(err){
            cb(!err && window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null);
          });
          return;
        }
      }catch(e){}
      cb(null);
    }

    function decided(api){
      if(stored()) return true;
      try{
        if(api && typeof api.currentVisitorConsent === 'function'){
          var c = api.currentVisitorConsent() || {};
          if(c.analytics === 'yes' || c.analytics === 'no') return true;
        }
      }catch(e){}
      return false;
    }

    function close(){
      var hadFocus = box.contains(doc.activeElement);
      box.hidden = true;
      if(hadFocus){ var m = doc.getElementById('main'); if(m){ try{ m.focus({preventScroll:true}); }catch(e){ m.focus(); } } }
    }

    function choose(accept){
      store(accept ? 'accepted' : 'declined');
      close();
      withPrivacy(function(api){
        if(!api || typeof api.setTrackingConsent !== 'function') return;
        try{
          api.setTrackingConsent({ analytics: accept, marketing: accept, preferences: accept, sale_of_data: accept }, function(){});
        }catch(e){}
      });
    }

    box.addEventListener('click', function(e){
      var b = e.target.closest ? e.target.closest('[data-cookie-choice]') : null;
      if(!b) return;
      choose(b.getAttribute('data-cookie-choice') === 'accept');
    });
    box.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){ close(); }
    });

    if(stored()) return;
    withPrivacy(function(api){ if(!decided(api)) box.hidden = false; });
  })();
})();
